module.exports = __webpack_public_path__ + "img/4-fr.704ee939.jpg";